import React, { useState, useEffect, useMemo } from 'react';
import { MDBDatatable, MDBTabsPane } from 'mdb-react-ui-kit';
import axios from 'axios';

const tableHeading = [
    { label: 'Amendment', field: 'amendment', sort: true },
    { label: 'Condensed Version', field: 'condensed', sort: true },
];

const Amendments = ({ active, bill, ordinal, onLoad, onError }) => {
    const params = useMemo(() => {
        const paramsObj = new URLSearchParams();
        paramsObj.append('legislatureOrdinal', `${ordinal}`);
        paramsObj.append('sessionOrdinal', `${bill.id.sessionId}`);
        paramsObj.append('billType', `${bill.billType}`);
        paramsObj.append('billNumber', `${bill.billNumber}`);
        return paramsObj;
    }, [ordinal, bill.id.sessionId, bill.billType, bill.billNumber]);

    const [amendmentsData, setAmendmentsData] = useState({
        columns: tableHeading,
        rows: []
    });

    useEffect(() => {
        async function fetchData() {
            try {
                const response = await axios.get(`${process.env.REACT_APP_LAWS_BACKEND_HOST}/docs/v1/documents/getBillAmendments?${params.toString()}`);
                const amendmentsWithPdfUrl = await Promise.all(
                    response.data.map(async (note) => {
                        try {
                            const pdfUrlResponse = await axios.post(`${process.env.REACT_APP_LAWS_BACKEND_HOST}/docs/v1/documents/shortPdfUrl?documentId=${note.id}`);
                            onLoad();
                            return { ...note, pdfUrl: pdfUrlResponse.data };
                        } catch (error) {
                            onError(error);
                            console.error(`Error fetching PDF URL for fiscal note ${note.id}: `, error);
                            return note;
                        }
                    })
                );

                const condensedVersions = amendmentsWithPdfUrl.filter(item => item.fileName.includes('condensed'));

                const formattedRows = amendmentsWithPdfUrl
                    .filter(item => !item.fileName.includes('condensed'))
                    .map(item => {
                        const baseFileName = item.fileName.split('_')[0];
                        const condensed = condensedVersions.find(condensedItem => condensedItem.fileName.startsWith(baseFileName));
                        return {
                            amendment: <a target='_blank' rel='noopener noreferrer' href={item.pdfUrl}>{item.fileName}</a>,
                            condensed: condensed
                                ? <a target='_blank' rel='noopener noreferrer' href={condensed.pdfUrl}>Yes</a>
                                : 'No'
                        };
                    });
                setAmendmentsData({
                    columns: tableHeading,
                    rows: formattedRows
                });
                onLoad();
            } catch (error) {
                onError(error);
                console.error("Error fetching data: ", error);
                throw error;
            }
        }
        fetchData();
    }, [params]);

    return (
        <MDBTabsPane show={active}>
            <div className="accordion-body">
                <div id="table-amendments_wrapper" className="dataTables_wrapper dt-bootstrap5 no-footer">
                    <MDBDatatable
                        data={amendmentsData}
                        pagination={false}
                        bordered
                        striped
                        noFoundMessage='No Amendments found'
                        fixedHeader
                        maxHeight='100vh'
                    />
                </div>
            </div>
        </MDBTabsPane>
    );
};

export default Amendments;